import _ from 'lodash'
import DataTypes, { AUXILIARY_TYPES } from 'constants/DataTypes'

const order = [
  DataTypes.THERMAL_INDICATOR,
  DataTypes.VENTILATION_INDICATOR,
  DataTypes.MOLD_INDICATOR,
  DataTypes.COVID_19,
  DataTypes.IAQ,
  DataTypes.GO_IAQS,
  DataTypes.GO_IAQS_DOMINANT,

  DataTypes.TEMPERATURE,
  DataTypes.HUMIDITY,
  DataTypes.CO2,
  DataTypes.FORMALDEHYDE,
  DataTypes.VOCS,
  DataTypes.VOCS_INDEX,
  DataTypes.PM1,
  DataTypes.PM25,
  DataTypes.PM4,
  DataTypes.PM10,
  DataTypes.CO,
  DataTypes.O3,
  DataTypes.NO2,

  DataTypes.NOISE,
  DataTypes.LIGHT,

  DataTypes.RADON,
  DataTypes.RADIANT_TEMPERATURE,
  DataTypes.NOX
]

const sortDataByOrder = data => _.sortBy(data, obj => _.indexOf(order, obj.type))

export const getDataSorted = (system, filter = []) => {
  return sortDataByOrder(system.data).filter(data => {
    return !AUXILIARY_TYPES.has(data.type) && !filter.includes(data.type)
  })
}

// Converts an Immutable.js collection (List/Map) into a plain JS array.
// Safe with null/undefined (returns []) and already-plain arrays (passthrough).
// Replaces the duplicated `collection.toArray().map(x => x.toJS())` idiom
// scattered across containers.
export const immutableToArray = collection => {
  if (!collection) return []
  if (Array.isArray(collection)) return collection

  return collection.toArray().map(item => item.toJS())
}
